module.exports = __webpack_public_path__ + "img/business_12.33a69f4d.jpg";